angular
	.module 'App.Repository'
	.factory 'MasterUserRepository', ['BaseRepository', (BaseRepository) ->
		class MasterUserRepository extends BaseRepository
			@resource = '/master_users'
			@isRestricted = true

			resetPassword: (userId) ->
				@post('user_reset_password', {user_id: userId}, null, '')

			updatePassword: (id, passwordData) ->
				@put("master_users/#{id}/reset_password", passwordData, null, '')

		return new MasterUserRepository()
	]
